import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

export interface SourTrackQuotationPickerData {
  candidates: { id: number; name?: string; budgetCode?: string }[];
  /** False when the list could not tell whether each quotation has sale lines. */
  linesVerified: boolean;
}

@Component({
  selector: 'app-sourtrack-quotation-picker',
  standalone: false,
  templateUrl: './sourtrack-quotation-picker.component.html',
  styleUrls: ['./sourtrack-quotation-picker.component.less'],
})
export class SourTrackQuotationPickerComponent {
  readonly data = inject<SourTrackQuotationPickerData>(NZ_MODAL_DATA);
  private readonly modalRef = inject<NzModalRef<SourTrackQuotationPickerComponent>>(NzModalRef);
  selectedId: number | null = null;

  pick(id: number): void {
    this.selectedId = id;
    this.modalRef.triggerOk();
  }

  cancel(): void {
    this.modalRef.close();
  }
}

/** Opens the picker; `onPick` runs only when the user chooses a quotation. */
export function openSourTrackQuotationPicker(
  modalService: NzModalService,
  data: SourTrackQuotationPickerData,
  onPick: (quotationId: number) => void
): void {
  modalService.create<SourTrackQuotationPickerComponent, SourTrackQuotationPickerData>({
    nzTitle: undefined,
    nzContent: SourTrackQuotationPickerComponent,
    nzData: data,
    nzFooter: null,
    nzClosable: false,
    nzCentered: true,
    nzWidth: 518,
    nzOnOk: (picker) => {
      if (picker.selectedId !== null) onPick(picker.selectedId);
    },
  });
}
